import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import useI18n from '@i18n';

import BaseIconTooltip from '@components/base/BaseIconTooltip';

import { IMotivationGoalPrepared } from '../interfaces';

import { COLORS_MAP } from '../config';

interface ILineHeaderProps {
    level: IMotivationGoalPrepared['level'];
    goalGmv: IMotivationGoalPrepared['goalGmv'];
    completed: IMotivationGoalPrepared['completed'];
    showTooltip: boolean;
    align: 'left' | 'center' | 'right';
    nowrap?: boolean;
    fullNowrap?: boolean;
    className?: string;
}

const alignClassNameMap = {
    left: 'items-start text-left',
    center: 'items-center text-center',
    right: 'items-end text-right',
};

const LineHeader: React.FC<ILineHeaderProps> = ({
    level,
    goalGmv,
    completed,
    showTooltip,
    align,
    nowrap = false,
    fullNowrap = false,
    className = '',
}) => {
    const { t } = useI18n('Statistic');
    return (
        <div className={`flex min-w-0 text-p1 text-blueGray-500 ${className}`}>
            <div className={`flex min-w-0 flex-col ${alignClassNameMap[align]}`}>
                <div className="flex items-start min-w-0 gap-1 xs:items-center">
                    <span
                        className="inline-block mt-1 rounded-full h-[6px] w-[6px] shrink-0 xs:hidden"
                        style={{ backgroundColor: COLORS_MAP[level].primary }}
                    />
                    <div
                        className={`min-w-0 leading-tight xs:max-w-full ${
                            fullNowrap ? 'whitespace-nowrap' : ''
                        }`}
                    >
                        <span className="hidden xs:inline">
                            {t('Target')}&nbsp;{level}&nbsp;-
                        </span>{' '}
                        <span
                            className={`font-medium text-p2 xs:text-p1 ${
                                nowrap ? 'whitespace-nowrap' : ''
                            }`}
                        >
                            {goalGmv}
                        </span>
                    </div>
                    {showTooltip ? (
                        <>
                            {!completed && (
                                <BaseIconTooltip
                                    className="text-yellow-400 shrink-0 text-p2"
                                    icon={faClock}
                                    text={t('Under consideration by AliExpress')}
                                />
                            )}
                            {completed && (
                                <BaseIconTooltip
                                    className="shrink-0 text-emerald-300 text-p2"
                                    icon={faCheck}
                                    text={t('Verified by AliExpress')}
                                />
                            )}
                        </>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default LineHeader;
